import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import {
  Entity,
  EntitySearchService,
} from '../../shared/entity-search/entity-search.service';
import {
  Cohort,
  CohortChanges,
  CohortEntity,
  CohortService,
} from '../services/cohort.service';

@Component({
  selector: 'dcc-cohort-approval-modal',
  templateUrl: './cohort-approval-modal.component.html',
  styleUrls: ['./cohort-approval-modal.component.scss'],
})
export class CohortApprovalModalComponent implements OnInit {
  cohortChanges: CohortChanges;
  cohort: Cohort;
  hasStatusChange = false;
  isLoading = true;
  currentApprovalOption = '';
  entitiesAdded: Entity[] = [];
  entitiesRemoved: Entity[] = [];
  legacyEntitiesAdded: CohortEntity[] = [];
  legacyEntitiesRemoved: CohortEntity[] = [];
  isDelete = false;

  constructor(
    private activeModal: NgbActiveModal,
    private entityService: EntitySearchService,
    private cohortService: CohortService,
    private toastr: ToastrService,
  ) {}

  ngOnInit(): void {
    this.loadData();
  }

  async loadData() {
    this.cohortChanges = await this.cohortService.getCohortChanges(
      this.cohort.name,
    );
    if (
      this.cohortChanges.statusChange.currentStatus !==
      this.cohortChanges.statusChange.proposedStatus
    ) {
      this.hasStatusChange = true;
    }

    try {
      this.isDelete = this.cohortChanges?.isDelete;
      await this.getAddedAndRemovedEntities();
    } catch (e) {
      this.toastr.error('Error getting entities');
    }

    this.isLoading = false;
  }

  close(success = false) {
    const result: CohortApprovalResult = { success };
    this.activeModal.close(result);
  }

  isNotNewCohort(): boolean {
    return !this.cohort.awaitingCreationApproval;
  }

  onApprovalOptionChange(event: any) {
    this.currentApprovalOption = event.target.value;
  }

  async onSave() {
    await this.cohortService.approveCohortChanges(
      this.cohort.name,
      this.currentApprovalOption,
    );
    this.close(true);
  }

  private async getAddedAndRemovedEntities() {
    this.cohortChanges?.entitiesAdded.forEach(async (entity) => {
      const resp = await this.entityService.searchEntities(entity.id);
      if (resp.length > 0) {
        this.entitiesAdded.push(resp[0]);
      } else {
        this.legacyEntitiesAdded.push(entity);
      }
    });

    this.cohortChanges?.entitiesRemoved.forEach(async (entity) => {
      const resp = await this.entityService.searchEntities(entity.id);
      if (resp.length > 0) {
        this.entitiesRemoved.push(resp[0]);
      } else {
        this.legacyEntitiesRemoved.push(entity);
      }
    });
  }
}

export interface CohortApprovalResult {
  success: boolean;
}
